<script setup>
defineProps({
  content: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: false,
  },
  titlePosition: {
    type: String,
    required: false,
    default: 'left',
  },
  headingLevel: {
    type: String,
    required: false,
    default: 'h3',
    validator: (val) => ['h1', 'h2', 'h3', 'h4', 'h5'].includes(val),
  },
});
</script>

<template>
  <div
    v-if="content"
    class="page-content"
  >
    <component
      :is="headingLevel"
      v-if="title"
      class="title"
      :class="[`title-${titlePosition}`]"
    >
      <span v-html="title" />
    </component>

    <div
      class="content"
      v-html="content"
    />
  </div>
</template>

<style lang="scss" scoped>
.page-content {
  display: block;

  :deep(.content) {
    p {
      @include body-2-reg;

      color: $wds-color-ink-darker;
      text-align: left;
      margin-bottom: $wds-spacing-m;
    }

    a {
      @include body-2-bld;

      color: $wds-color-ink-darker;
      text-decoration: underline;
      padding: $wds-spacing-s 0;
      background: none;

      &:hover {
        text-decoration: underline;
        cursor: pointer;
        color: $wds-color-ink;
      }

      &:focus-visible {
        padding: 0;
        margin: $wds-spacing-s 0;
        outline-offset: $wds-spacing-xxs !important;
        outline: $wds-spacing-xxs solid $wds-color-ink-darker !important;
        border-radius: $wds-spacing-xs;
      }
    }

    h2 {
      @include title-4-bld;
    }

    h3 {
      @include title-5-bld;
    }

    h4 {
      @include title-6-bld;
    }

    h5,
    h6 {
      @include body-1-bld;
    }

    ol,
    ul {
      margin-left: $wds-spacing-m;
      margin-bottom: $wds-spacing-m;
    }

    li {
      @include body-2-reg;

      list-style-position: outside;
      list-style-type: disc;
      margin: 0 0 $wds-spacing-xs $wds-spacing-m;
    }

    ol > li {
      list-style-type: numeric;

      h3 {
        @include body-1-reg;

        text-align: left;
      }
    }
  }

  .title {
    @include title-3-bld;

    text-align: left;
    margin-bottom: $wds-spacing-l;
    color: $wds-color-ink-darker;

    :deep(span) {
      > span {
        color: $wds-color-purple;
      }
    }
  }

  .title.title-center {
    text-align: center;
  }

  @include desktop {
    .title {
      @include title-1-bld;
    }
  }
}
</style>
